

import { instance } from './_config.js'


const getGenerateFiles = async (obj) => {
    try {
        const rs = await instance.get(`/generate_files`, {
            params: obj,
            responseType: 'blob'  // ⬅️ обязательно!
        })
        if (rs) {
            return rs
        }
    }
    catch (err) {
        console.log(err)
        return null
    }
}

export { getGenerateFiles }


